export const MIN_COLLAB_ROOM_COUNT = 1;
export const MAX_COLLAB_ROOM_COUNT = 12;

/**
 * Keep input text separate from the committed breakout configuration. This
 * intentionally accepts temporary empty text in the caller, returning null
 * only when an action needs a valid room count.
 */
export function committedCollabRoomCount(value: string): number | null {
  const trimmed = value.trim();
  if (!/^\d+$/.test(trimmed)) return null;
  const count = Number(trimmed);
  return Number.isInteger(count) && count >= MIN_COLLAB_ROOM_COUNT && count <= MAX_COLLAB_ROOM_COUNT
    ? count
    : null;
}
